<ion-header>
    <ion-toolbar>
<!--        <ion-buttons slot="start">-->
<!--            <ion-button (click)="cancelModal()">-->
<!--                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>-->
<!--            </ion-button>-->
<!--        </ion-buttons>-->
        <ion-label class="ion-text-wrap ion-padding-start">Accessories for {{equipment.description}}</ion-label>
        <ion-searchbar placeholder="Search Product" debounce="300" [(ngModel)]="queryText"></ion-searchbar>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-refresher slot="fixed" (ionRefresh)="fetchAccessories($event)">
        <ion-refresher-content
                pullingIcon="arrow-dropdown"
                pullingText="Pull to refresh"
                refreshingSpinner="circles"
                refreshingText="Fetching Documents...">
        </ion-refresher-content>
    </ion-refresher>
    <ion-list>
        <ion-item *ngFor="let acc of tempList  | filterDetailLine: queryText">
            <ion-label>
                <p>{{acc.equipment.description}}</p>
                <p *ngIf="acc.equipment.reg">{{acc.equipment.reg}}</p>
                <p>{{acc.equipment.stat}}</p>
            </ion-label>
            <ion-checkbox slot="end" checked="true" [(ngModel)]="acc.isChecked"></ion-checkbox>
        </ion-item>
    </ion-list>

    <ion-fab vertical="bottom" horizontal="end" >
        <ion-fab-button (click)="saveAccessories()" color="success">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>

</ion-content>
